
    import { mapState, mapMutations } from 'vuex';
    import C1Disclosure from '@/components/Partials/C1Disclosure';

    export default {
        name: 'ApplyFormFooter',
        components: { C1Disclosure },
        data() {
            return {};
        },

        computed: {
            ...mapState({
                $_job: state => state.job.job,
            }),
        },

        methods: {
            ...mapMutations('jobApplication', {
                $_CHECK_RESUME_REVIEW: 'CHECK_RESUME_REVIEW',
                $_UNCHECK_RESUME_REVIEW: 'UNCHECK_RESUME_REVIEW',
            }),
        },
    };
